// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lightColor[data-v-028ec559]{background-color:#f5f5f9;color:#000}.deepColor[data-v-028ec559]{background-color:#879dc9;color:#fff}.deepLightColor[data-v-028ec559]{background-color:#fff;color:#000}.commonBtn[data-v-028ec559]{cursor:pointer;width:-moz-fit-content;width:fit-content;line-height:30px;border-radius:5px;min-width:3rem;float:right;height:30px;padding:0 20px;text-align:center}", ""]);
// Exports
module.exports = exports;
